import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./index.module.scss";
import styleUi from "./AlertCustom.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import * as YStyle from "../Styleds";

const AlertCustom = ({ setModalType, addModalType, arg }) => {
    const [inProp, setInProp] = useState(false);
    useEffect(() => {
        setInProp(true);
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.OpacityEnterActive,
                enterDone: style.OpacityEnterDone,
                exitActive: style.OpacityExit,
                exitDone: style.OpacityExitActive
            }}
            >
                <div className={`${style.Opacity}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "AlertCustom"))
                        }}
                    >
                        <div className={`${style.centerPage}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            {!arg.type &&
                                <div className={styleUi.app}>
                                    <YStyle.Span size={17}>{arg.title}</YStyle.Span>
                                    <YStyle.Span size={13} fontWeight={400} fontFamily="SF Pro" style={{ margin: ".5rem 0" }}>{arg.desc}</YStyle.Span>
                                    {
                                        arg.options.map((v, k) => {
                                            return <div onClick={e => {
                                                v.cb();
                                                setInProp(false)
                                            }}>
                                                <div className={styleUi.hr}></div>
                                                <YStyle.Span size={17} fontWeight={400}>{v.label}</YStyle.Span>
                                            </div>
                                        })
                                    }
                                </div>
                            }
                            {arg.type === 2 &&
                                <div className={styleUi.type2}>
                                    <YStyle.Span size={17}>{arg.title}</YStyle.Span>
                                    <YStyle.Col style={{ color: "#00000099" }}>
                                        <YStyle.Span size={13} fontFamily="SF Pro">{arg.desc1}</YStyle.Span>
                                        <YStyle.Span size={13} fontFamily="SF Pro">{arg.desc2}</YStyle.Span>
                                    </YStyle.Col>
                                    <YStyle.Col gap=".4rem">
                                        {
                                            arg.options.map((v, k) => {
                                                if (v.color === "black") {
                                                    return <YStyle.BTN2 key={k} style={{ width: "100%", background: "#000000", color: "#fff", padding: ".8rem" }} onClick={e => {
                                                        v.cb();
                                                        setInProp(false);
                                                    }}>
                                                        <YStyle.Span size={17}>{v.label}</YStyle.Span>
                                                    </YStyle.BTN2>
                                                }
                                                else if (v.color === "white") {
                                                    return <YStyle.BTN2 key={k} style={{ width: "100%", background: "#ffffff", color: "#000", padding: ".8rem",borderWidth:"1px" }} onClick={e => {
                                                        v.cb();
                                                        setInProp(false);
                                                    }}>
                                                        <YStyle.Span size={17}>{v.label}</YStyle.Span>
                                                    </YStyle.BTN2>
                                                }
                                            })
                                        }
                                    </YStyle.Col>
                                </div>
                            }
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(AlertCustom);